import { ComponentRepresentation } from '@ardoq/basic-components';
import { classes } from '@ardoq/common-helpers';
import { dataModelId } from 'tabview/graphComponent/graphComponentUtil';
import { COMPONENT_ID_ATTRIBUTE } from '@ardoq/global-consts';
import { BULK_POPOVER_ATTR } from '@ardoq/popovers';
import type { RepresentationData } from '@ardoq/data-model';
import type { GraphItemModel } from 'graph/GraphItem';
import type { Node } from 'graph/types';

type RoadMapViewItemProperties = {
  node: Node<GraphItemModel>;
  isLegendItem: boolean;
  label: string;
  representationData: RepresentationData | null;
};
const RoadMapViewItem = ({
  node,
  label,
  isLegendItem,
  representationData,
}: RoadMapViewItemProperties) => {
  const modelId = dataModelId(node);

  return (
    <div
      className={classes('item', node.getCSS({ useAsBackgroundStyle: true }))}
      tabIndex={0}
      {...(isLegendItem
        ? {}
        : {
            [COMPONENT_ID_ATTRIBUTE]: modelId,
            [BULK_POPOVER_ATTR]: 'true',
          })}
    >
      <span className="svgIcon">
        <div
          style={{
            display: 'flex',
            height: 18,
            width: 18,
            alignItems: 'center',
          }}
        >
          {representationData && (
            <ComponentRepresentation {...representationData} />
          )}
        </div>
      </span>
      <span className="name">{label}</span>
    </div>
  );
};

export { RoadMapViewItem };
